import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from '@/app/app.tsx';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_ENVIRONMENT ?? 'development',
  // browserTracingIntegration must be registered at init (synchronously) so the
  // pageload span is captured; without it the configured tracesSampleRate is inert.
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: import.meta.env.VITE_ENVIRONMENT === 'production' ? 0.2 : 1.0,
  replaysSessionSampleRate: import.meta.env.VITE_ENVIRONMENT === 'production' ? 0.1 : 1.0,
  replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: false,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App/>
  </StrictMode>,
);
